export function updateVacanciesState(state, payload) {
  state[payload.state] = payload.data;
}
